// extracted by mini-css-extract-plugin
module.exports = {"size":"30px","checkbox":"XZDcW","radio":"yOoVJ","label":"xTVGY"};